import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import pre from "../../assets/pre.jpeg";
/* ================= DATA ================= */

const cards = [
  { step: "01", title: "IELTS", logo: "https://upload.wikimedia.org/wikipedia/commons/7/7f/IELTS_logo.svg" },
  { step: "02", title: "TOEFL", logo: "https://upload.wikimedia.org/wikipedia/commons/3/32/TOEFL_logo_2024.svg" },
  { step: "03", title: "GRE", logo: "https://upload.wikimedia.org/wikipedia/commons/c/c4/GRE_logo_2024.svg" },
  { step: "04", title: "GMAT", logo: "https://upload.wikimedia.org/wikipedia/commons/0/0c/GMAT_LOGO_POS_RGB.svg" },
  { step: "05", title: "SAT", logo: "https://upload.wikimedia.org/wikipedia/commons/5/5a/SAT_logo_%282017%29.svg" },
  { step: "06", title: "PEARSON", logo: pre },
  { step: "07", title: "Duolingo", logo: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Duolingo_logo_%282019%29.svg" },
 
];

/* ================= ANIMATION VARIANTS ================= */

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.15 },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};  

/* ================= COMPONENT ================= */

export default function Cards() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="relative bg-[#092CB4] py-10 md:py-12 overflow-hidden">

      {/* MOBILE TITLE */}
      <motion.div
        variants={cardVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        className="block lg:hidden text-center mb-6 px-4"
      >
        <h2 className="text-white text-3xl font-semibold">
          We Offer Test Trainings
        </h2>
      </motion.div>

      {/* DESKTOP LEFT TITLE */}
      <motion.div
        variants={cardVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        className="absolute left-8 top-1/2 -translate-y-1/2 z-30 hidden lg:block"
      >
        <h2 className="text-white text-4xl font-semibold leading-tight">
          We Offer <br /> Test Trainings
        </h2>
      </motion.div>

      {/* MARQUEE */}
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        className="relative lg:ml-[340px] overflow-hidden marquee-mask px-4 lg:px-0"
      >
        <div className="marquee-track">

          {[...cards, ...cards].map((item, i) => (
            <motion.div
              key={i}
              variants={cardVariants}
              className="
                marquee-card
                bg-white
                rounded-md
                border border-gray-200
                
                min-w-[115px]
                h-[75px]
                px-2
                
                flex flex-col items-center justify-center text-center
                
                shadow-sm
                transition-all duration-300
                hover:shadow-md
                hover:scale-[1.05]
              "
            >
              {/* LOGO */}
              <img
                src={item.logo}
                alt={item.title}
                className="h-12 mb-1 object-contain"
              />

              {/* TITLE */}
              <h3 className="text-[13px] font-semibold tracking-wide">
                {item.title}
              </h3>
            </motion.div>
          ))}

        </div>
      </motion.div>

    </section>
  );
}
